const initialState = {
  isLoading: false,
  isOpen: false,
  isGiftActive: false,
  items: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_LOADING':
      return {
        ...state,
        isLoading: true,
      };
    case 'UNSET_LOADING':
      return {
        ...state,
        isLoading: false,
      };
    case 'TOGGLE_OPEN_CART':
      return {
        ...state,
        isOpen: !state.open,
      };
    case 'OPEN_CART':
      return {
        ...state,
        isOpen: true,
      };
    case 'CLOSE_CART':
      return {
        ...state,
        isOpen: false,
      };
    case 'POPULATE_ITEMS':
      return {
        ...state,
        items: action.items,
      };
    case 'RECEIVE_ITEM': {
      let itemExistsInCart = false;
      const items = state.items.map((item) => {
        if (item.error) delete item.error;
        if (item.key === action.lineItem.key) {
          itemExistsInCart = true;
          return {
            ...item,
            quantity: action.lineItem.quantity,
            key: action.lineItem.key,
          };
        }
        return item;
      });
      if (!itemExistsInCart && action.variant) {
        // correctly format the new line item properties to match the rest
        /// of the line items generated on page load
        const clonedVariant = JSON.parse(JSON.stringify(action.variant));
        if (action.lineItem.properties) {
          clonedVariant.properties = Object.keys(action.lineItem.properties).map((property) => [
            property, action.lineItem.properties[property]]);
        }
        if (action.lineItem.measurements) {
          clonedVariant.measurements = action.lineItem.measurements;
        }
        // add newly added line item to the store
        items.unshift({
          ...clonedVariant,
          quantity: action.quantity || 1,
          key: action.lineItem.key,
          productId: action.lineItem.product_id,
        });
      }

      return {
        ...state,
        items,
      };
    }
    case 'RECEIVE_ITEMS': {

      const updatedItems = [];
      action.items.forEach((updatedItem) => {
        // Match by variant_id first (more reliable when discounts change the key hash)
        // Fall back to key matching if variant_id doesn't match
        const copiedStateItem = state.items.find((stateItem) => {
          const apiVariantId = updatedItem.variant_id?.toString() || updatedItem.id?.toString();
          const stateVariantId = stateItem.variantId?.toString();

          // Try matching by variant ID first
          if (apiVariantId && stateVariantId && apiVariantId === stateVariantId) {
            return true;
          }

          // Fall back to key matching (for exact match)
          return updatedItem.key.toString() === stateItem.key;
        });
        if (copiedStateItem) {
          if (copiedStateItem.error) delete copiedStateItem.error;
          updatedItems.push({
            ...copiedStateItem,
            quantity: updatedItem.quantity,
            key: updatedItem.key, // Update key to match API (important for future updates)
          });
        }
      });
      return {
        ...state,
        items: updatedItems,
      };
    }
    case 'RECEIVE_ITEM_ERROR': {
      const items = state.items.map((item) => {
        if (item.variantId === action.id) {
          return {
            ...item,
            error: action.error,
          };
        }
        if (item.error) delete item.error;
        return item;
      });
      return {
        ...state,
        items,
      };
    }

    case 'SET_GIFT':
      return {
        ...state,
        isGiftActive: true,
      };
    case 'UNSET_GIFT':
      return {
        ...state,
        isGiftActive: false,
      };

    default:
      return state;
  }
};
